var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F5F5F5;}\r\n\t.st1{fill:#EBEBEB;}\r\n\t.st2{fill:#27DEBF;}\r\n\t.st3{opacity:0.2;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#E0E0E0;}\r\n\t.st6{fill:#F0F0F0;}\r\n\t.st7{fill:#455A64;}\r\n\t.st8{fill:#37474F;}\r\n\t.st9{fill:#263238;}\r\n\t.st10{fill:#FFFFFF;stroke:#27DEBF;stroke-miterlimit:10;}\r\n\t.st11{fill:#27DEBF;stroke:#27DEBF;stroke-miterlimit:10;}\r\n\t.st12{opacity:0.7;fill:#FFFFFF;}\r\n\t.st13{opacity:0.1;}\r\n\t.st14{opacity:0.2;fill:#FFFFFF;}\r\n\t.st15{fill:#FFA8A7;}\r\n\t.st16{fill:#F28F8F;}\r\n\t.st17{opacity:0.3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    className: "st0",
    d: "M81.71,437.82c92.94,44.3,243.64,44.3,336.58,0c92.94-44.3,92.94-116.12,0-160.42 c-92.94-44.3-243.64-44.3-336.58,0C-11.24,321.7-11.24,393.52,81.71,437.82z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    className: "st1",
    d: "M396.06,400.76c12.1,5.77,31.73,5.77,43.83,0c12.1-5.77,12.1-15.12,0-20.89 c-12.1-5.77-31.73-5.77-43.83,0C383.95,385.63,383.95,394.99,396.06,400.76z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_292_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_378_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_372_",
    className: "st2",
    d: "M74.59,392.43l10.96-6.33c0,0,9.04-6.64,13.52-18.98c3.39-9.33,2.92-16.44,0.49-19.99 c-2.99-4.38-10.72-3.61-11.03,5.62C87.92,370.93,82.62,383.51,74.59,392.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st3",
    d: "M74.59,392.43l10.96-6.33c0,0,9.04-6.64,13.52-18.98c3.39-9.33,2.92-16.44,0.49-19.99 c-2.99-4.38-10.72-3.61-11.03,5.62C87.92,370.93,82.62,383.51,74.59,392.43z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.59,393.1c-0.21,0-0.42-0.1-0.56-0.29c-0.21-0.31-0.14-0.73,0.17-0.94 c25.35-17.54,20.44-41.99,20.39-42.23c-0.08-0.36,0.15-0.72,0.52-0.8c0.37-0.08,0.72,0.15,0.8,0.52 c0.05,0.25,5.18,25.55-20.94,43.63C74.85,393.07,74.72,393.1,74.59,393.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_379_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_364_",
    className: "st2",
    d: "M52.67,405.08c0,0-3.81-3.11-2.89-7.31c0.92-4.21,3.38-7.23-0.85-12.65 c-4.23-5.43-5.32-12.65-0.35-16.57c3.85-3.03,9.85,1.26,12.01-6.77c1.58-5.85,1.04-18.82,8.51-23.13 c7.47-4.31,12.1,2.18,10.96,10.97c-1.03,7.87-2.47,15.44-1.36,17.5c2.18,4.03,5.92,3.49,5.75,10.88 c-0.16,6.88-6.66,12.57-6.66,12.57L52.67,405.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.2,398.52c-0.34,0-0.63-0.25-0.67-0.59c-1.93-15.98,2.67-43.58,6.47-51.78c0.16-0.34,0.55-0.49,0.9-0.33 c0.34,0.16,0.48,0.56,0.33,0.89c-3.74,8.06-8.21,35.78-6.36,51.05c0.04,0.37-0.22,0.7-0.59,0.75 C65.26,398.52,65.23,398.52,65.2,398.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.84,386.08c-0.1,0-0.2-0.02-0.3-0.07c-4.68-2.29-7.65-10.42-7.77-10.76c-0.13-0.35,0.06-0.74,0.41-0.86 c0.35-0.13,0.74,0.06,0.86,0.41c0.03,0.08,2.91,7.96,7.09,10c0.33,0.16,0.47,0.57,0.31,0.9 C65.33,385.94,65.09,386.08,64.84,386.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.76,391.46c-0.27,0-0.52-0.16-0.63-0.42c-0.14-0.35,0.03-0.74,0.38-0.88 c7.88-3.16,12.79-12.54,12.83-12.64c0.17-0.33,0.58-0.46,0.91-0.29c0.33,0.17,0.46,0.58,0.29,0.91 c-0.21,0.4-5.19,9.93-13.53,13.27C64.93,391.45,64.85,391.46,64.76,391.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_366_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_374_",
    className: "st2",
    d: "M340.11,318.9c0,0-5.9-9.54-6.47-19.92c-0.57-10.39,1.71-14.7,4.84-15.93 c3.13-1.24,3.36,2.57,4.98,4.83c1.62,2.26,4.88,0.97,6.09-6.06c1.21-7.02,5.64-18.92,14.8-21.2c10.12-2.51,4.69,9.36,2.15,13.99 c-2.54,4.63-4.52,10.94-2.85,12.65c1.67,1.72,4.27-1.46,6.76,1.49c3.01,3.55-6.34,16.31-11.7,19.41L340.11,318.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.19,314.89c-0.01,0-0.02,0-0.04,0c-0.37-0.02-0.66-0.34-0.64-0.71c1.48-27.62,14.96-46.75,15.1-46.94 c0.22-0.3,0.64-0.37,0.94-0.16c0.3,0.22,0.37,0.64,0.16,0.94c-0.13,0.19-13.39,19.02-14.85,46.22 C348.84,314.61,348.54,314.89,348.19,314.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.96,306.92c-0.11,0-0.22-0.03-0.33-0.08c-3.78-2.09-5.87-8.29-5.96-8.56 c-0.12-0.35,0.07-0.74,0.43-0.85c0.35-0.12,0.74,0.07,0.85,0.43c0.02,0.06,2.01,5.97,5.33,7.8c0.33,0.18,0.44,0.59,0.26,0.92 C349.42,306.8,349.19,306.92,348.96,306.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M349.62,302.84c-0.3,0-0.58-0.2-0.65-0.51c-0.09-0.36,0.13-0.73,0.49-0.82c9.74-2.46,13.11-7.56,13.14-7.61 c0.2-0.31,0.62-0.4,0.93-0.21c0.31,0.2,0.41,0.62,0.21,0.93c-0.14,0.23-3.65,5.59-13.95,8.2 C349.73,302.83,349.67,302.84,349.62,302.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_363_",
    className: "st2",
    d: "M193.38,297.93c0,0-12.93-3.15-13.61-27.37c-0.73-26.14,3.17-56.64-12.09-59.12 c-15.25-2.48-23.81,16.22-23.62,37.96c0.17,19.08,7.86,60.5,49.31,68.61L193.38,297.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st3",
    d: "M193.38,297.93c0,0-12.93-3.15-13.61-27.37c-0.73-26.14,3.17-56.64-12.09-59.12 c-15.25-2.48-23.81,16.22-23.62,37.96c0.17,19.08,7.86,60.5,49.31,68.61L193.38,297.93z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193.38,315.52c-0.04,0-0.08,0-0.12-0.01c-9.33-1.7-16.92-6.83-22.56-15.25 c-16.76-25-11.48-71.66-9.74-79.82c0.08-0.36,0.43-0.59,0.8-0.52c0.36,0.08,0.6,0.44,0.52,0.8c-1.71,8.06-6.95,54.18,9.55,78.79 c5.43,8.11,12.73,13.04,21.69,14.67c0.37,0.07,0.61,0.42,0.54,0.79C193.98,315.29,193.7,315.52,193.38,315.52z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_380_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_361_",
    className: "st2",
    d: "M193.38,377.7c-13.37,1.81-35.1,1.78-47.61-8.09c-12.51-9.87-9.91-18.37-5.1-21.92 c4.81-3.55,8.99-7.6,0.71-15.48c-8.28-7.87-21.59-20.53-25.89-39.51c-4.3-18.98-2.18-30.84,6.28-34.8 c8.22-3.84,10.38,2.26,15.41,14.83c5.03,12.57,16.35,1.79,26.03,5.72c9.68,3.92,9.3,11.69,9.91,18.37 c0.61,6.68,3.81,8.53,9.29,8.53c5.48,0,10.96,3.16,10.96,9.49L193.38,377.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193.38,355.66c-0.06,0-0.12-0.01-0.18-0.02c-0.58-0.16-14.41-4.19-34.54-22.68 c-21.44-19.7-31.57-49.23-31.67-49.53c-0.12-0.35,0.07-0.74,0.42-0.85c0.35-0.12,0.74,0.07,0.85,0.42 c0.1,0.29,10.12,29.51,31.3,48.97c19.86,18.24,33.85,22.33,33.99,22.37c0.36,0.1,0.57,0.47,0.47,0.83 C193.94,355.47,193.67,355.66,193.38,355.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.26,337.67c-0.27,0-0.52-0.16-0.63-0.43c-4.33-11.12-5.31-34.9-5.35-35.91 c-0.01-0.37,0.28-0.69,0.65-0.7c0.35,0,0.69,0.28,0.7,0.65c0.01,0.24,1.01,24.56,5.26,35.47c0.14,0.35-0.04,0.74-0.38,0.87 C164.42,337.65,164.34,337.67,164.26,337.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M164.14,353.66c-2.1,0-3.55-0.16-3.72-0.19c-0.37-0.04-0.63-0.38-0.59-0.75c0.04-0.37,0.38-0.64,0.75-0.59 c0.13,0.01,12.68,1.43,18.44-4.45c0.26-0.27,0.69-0.27,0.95-0.01c0.27,0.26,0.27,0.69,0.01,0.95 C175.77,352.94,168.54,353.66,164.14,353.66z"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Gear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_272_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_561_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_562_",
    className: "st5",
    d: "M154.43,98.25l-1.45-8.41l-7.5,4.94c-0.75-1.44-1.72-2.59-2.85-3.46l3.59-9.71l-6.69-1.5 l-4.94,9.41c-1.64,0.25-3.36,0.8-5.15,1.68l-2.14-7.09l-8.01,6.3l0.52,8.36c-1.62,1.8-3.1,3.78-4.43,5.85l-6.62-0.33l-4.64,10.4 l5.68,2.42c-0.6,2.24-0.99,4.46-1.12,6.59l-7.21,6.63l1.45,8.41l7.5-4.94c0.75,1.44,1.72,2.59,2.85,3.46l-3.59,9.71l6.69,1.5 l7.07-6.89c1.64-0.25,1.24-3.33,3.02-4.2l2.14,7.09l8.01-6.3l-0.21-3.29c1.62-1.8,7.74-5.78,9.06-7.86l1.66-2.74l4.64-10.4 l-2.16-3.91l-2.4-5.1L154.43,98.25z M129.97,125.96c-6.14,4.83-8.01,5.88-9.13-0.57c-1.11-6.45,2.48-16.29,8.63-21.12 c6.14-4.83,8.5-5.19,9.61,1.26S136.12,121.13,129.97,125.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_271_",
    className: "st0",
    points: "139.53,80.1 148.28,85.15 143.34,94.56 134.59,89.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_144_",
    className: "st0",
    points: "161.73,94.88 154.23,99.82 145.48,94.77 152.98,89.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_143_",
    className: "st5",
    points: "160.53,118.93 154.84,116.51 146.1,111.47 151.78,113.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_621_",
    className: "st5",
    points: "109.71,146.97 118.45,152.01 122.04,142.3 113.3,137.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_142_",
    className: "st5",
    points: "137.36,149.51 128.61,144.47 126.48,137.38 135.22,142.42  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_516_",
    className: "st1",
    d: "M163.18,103.29l-1.45-8.41l-7.5,4.94c-0.75-1.44-1.72-2.59-2.85-3.46l3.59-9.71l-6.69-1.5 l-4.94,9.41c-1.64,0.25-3.36,0.8-5.15,1.68l-2.14-7.09l-8.01,6.3l0.52,8.36c-1.62,1.8-3.1,3.78-4.43,5.85l-6.62-0.33l-4.64,10.4 l5.68,2.42c-0.6,2.24-0.99,4.45-1.12,6.59l-7.21,6.63l1.45,8.41l7.5-4.94c0.75,1.44,1.72,2.59,2.85,3.46l-3.59,9.71l6.69,1.5 l4.94-9.41c1.64-0.25,3.36-0.8,5.15-1.68l2.14,7.09l8.01-6.3l-0.52-8.36c1.62-1.8,3.1-3.78,4.43-5.85l6.62,0.33l4.64-10.4 l-5.68-2.42c0.6-2.24,0.99-4.45,1.12-6.59L163.18,103.29z M138.72,131.01c-6.14,4.83-12.02,3.51-13.13-2.94 c-1.11-6.45,2.97-15.6,9.11-20.43c6.14-4.83,12.02-3.52,13.13,2.94C148.94,117.03,144.86,126.18,138.72,131.01z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_603_",
    className: "st0",
    points: "136.06,89.14 127.31,84.09 119.3,90.39 128.05,95.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_614_",
    className: "st5",
    points: "119.3,90.39 119.83,98.75 128.57,103.8 128.05,95.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_615_",
    className: "st0",
    points: "124.15,109.65 115.4,104.6 108.78,104.28 117.53,109.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_616_",
    className: "st5",
    points: "108.78,104.28 104.14,114.67 112.89,119.72 117.53,109.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_617_",
    className: "st0",
    points: "117.45,128.73 108.7,123.69 101.49,130.32 110.24,135.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_619_",
    className: "st5",
    points: "111.69,143.77 102.94,138.73 101.49,130.32 110.24,135.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_145_",
    className: "st0",
    points: "148.28,85.15 139.53,80.1 146.22,81.6 154.96,86.64  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_558_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_579_",
    className: "st5",
    d: "M115.24,60.1V47.54l-10,4.51c-0.6-2.32-1.52-4.31-2.7-5.95l6.3-12.7l-7.69-4.44l-7.85,11.8 c-2.01-0.2-4.19,0-6.5,0.64l-1.1-10.91l-10.88,6.28l-1.1,12.18c-2.31,2.03-4.49,4.35-6.5,6.87l-7.85-2.74L51.68,66.4l6.3,5.43 c-1.18,3-2.1,6.05-2.7,9.07l-10,7.04v12.56l10-4.51c0.6,2.32,1.52,4.31,2.7,5.95l-6.3,12.7l7.69,4.44l7.85-11.8 c2.01,0.2,4.19,0,6.5-0.64l1.1,10.91l10.88-6.28l1.1-12.18c3.24-1.08,6.71-3.59,8.72-6.11l5.63,1.98l7.69-13.32l-4.72-4.07 c1.18-3,1.3-7.8,1.12-10.43L115.24,60.1z M80.26,91.46c-8.35,4.82-13.53,1.4-13.53-8.24c0-9.64,6.9-21.44,15.24-26.26 c8.35-4.82,13.4-1.31,13.4,8.32C95.37,74.93,88.61,86.64,80.26,91.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_582_",
    className: "st0",
    points: "109.9,34 101.15,28.96 93.3,40.76 102.05,45.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_581_",
    className: "st0",
    points: "123.99,52.58 115.24,47.54 105.24,52.05 113.99,57.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_580_",
    className: "st5",
    points: "83.57,122.59 74.82,117.54 73.73,106.63 82.48,111.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_576_",
    className: "st5",
    points: "51.68,114.63 60.43,119.68 66.73,106.98 57.98,101.93  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_524_",
    className: "st1",
    d: "M123.99,65.14V52.58l-10,4.51c-0.6-2.32-1.52-4.31-2.7-5.95l6.3-12.7L109.9,34l-7.85,11.8 c-2.01-0.2-4.19,0-6.5,0.64l-1.1-10.91l-10.88,6.28l-1.1,12.18c-2.31,2.03-4.49,4.35-6.5,6.87l-7.85-2.74l-7.69,13.32l6.3,5.43 c-1.18,3-2.1,6.05-2.7,9.07l-10,7.04v12.56l10-4.51c0.6,2.32,1.52,4.31,2.7,5.95l-6.3,12.7l7.69,4.44l7.85-11.8 c2.01,0.2,4.19,0,6.5-0.64l1.1,10.91l10.88-6.28l1.1-12.18c2.31-2.03,4.49-4.35,6.5-6.87l7.85,2.74l7.69-13.32l-6.3-5.43 c1.18-3,2.1-6.05,2.7-9.07L123.99,65.14z M89.01,96.51c-8.35,4.82-15.11,0.91-15.11-8.72s6.77-21.35,15.11-26.17 c8.35-4.82,15.11-0.91,15.11,8.72C104.12,79.97,97.36,91.69,89.01,96.51z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_559_",
    className: "st6",
    points: "67.22,55.81 75.97,60.86 68.12,58.12 59.38,53.07  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_563_",
    x: 52.21,
    y: 57.21,
    transform: "matrix(0.4996 -0.8662 0.8662 0.4996 -23.955 83.0429)",
    className: "st0",
    width: 15.38,
    height: 10.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_564_",
    className: "st5",
    points: "51.68,66.4 60.43,71.44 66.73,76.87 57.98,71.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_574_",
    className: "st0",
    points: "55.28,80.89 64.03,85.94 54.03,92.97 45.29,87.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_575_",
    className: "st5",
    points: "45.29,87.93 54.03,92.97 54.03,105.53 45.29,100.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_602_",
    className: "st0",
    points: "94.45,35.53 85.7,30.49 74.82,36.77 83.57,41.81  "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_362_",
    className: "st5",
    d: "M206.67,395.75l126.83-73.22c1.29-0.75,1.29-1.95,0-2.7l-11.73-6.79 c-1.29-0.75-3.38-0.75-4.67,0l-126.86,73.22c-1.29,0.75-1.29,1.95,0,2.7l11.76,6.79C203.29,396.49,205.38,396.49,206.67,395.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st7",
    d: "M329.99,39.84l-114.34,66.01c-3.23,1.86-5.84,6.39-5.84,10.12v271.22 c0,3.73,2.62,5.23,5.84,3.37l114.34-66.01c3.23-1.86,5.84-6.39,5.84-10.12l0-271.22C335.83,39.49,333.22,37.98,329.99,39.84z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st8",
    d: "M215.65,105.86l114.34-66.01c2.88-1.67,5.27-0.63,5.75,2.27c-0.44-3.48-2.83-7.33-5.75-9.02 l-4.76-2.75c-3.23-1.86-8.46-1.86-11.68,0L199.22,96.37c-1.61,0.93-3.07,2.53-4.13,4.36l16.44,9.49 C212.58,108.38,214.04,106.79,215.65,105.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st9",
    d: "M193.38,377.7c0,3.73,2.61,8.26,5.84,10.12l4.76,2.75c2.92,1.68,7.46,1.83,10.69,0.47 c-2.75,1.04-4.85-0.51-4.85-3.84V115.97c0-1.86,0.65-3.93,1.71-5.76l-16.44-9.49c-1.06,1.83-1.71,3.89-1.71,5.76L193.38,377.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st4",
    d: "M218.8,142l108.05-62.38c1.94-1.12,3.51-0.21,3.51,2.02l0,200.69c0,2.24-1.57,4.95-3.51,6.07 L218.8,350.79c-1.94,1.12-3.5,0.21-3.5-2.02l0-200.69C215.29,145.84,216.86,143.12,218.8,142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st8",
    d: "M272.82,83.14c-1.13,0.66-2.05,2.25-2.05,3.56c0,1.31,0.92,1.84,2.05,1.19 c1.14-0.65,2.05-2.25,2.05-3.56C274.88,83.01,273.96,82.48,272.82,83.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st8",
    d: "M272.83,329.23c-4.48,2.59-8.11,8.88-8.11,14.05c0,5.17,3.63,7.27,8.11,4.68 c4.48-2.59,8.11-8.88,8.11-14.05C280.94,328.74,277.31,326.64,272.83,329.23z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_47_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st8",
    d: "M253.42,104.01c-2.27,1.31-4.11,4.5-4.11,7.12c0,2.62,1.84,3.68,4.11,2.37 c2.27-1.31,4.11-4.5,4.11-7.12C257.53,103.77,255.69,102.7,253.42,104.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    className: "st8",
    d: "M263.46,103.13c0,1.75,1.31,2.41,2.92,1.48l27.04-15.61c1.61-0.93,2.92-3.1,2.92-4.85 c0-1.75-1.31-2.41-2.92-1.48l-27.03,15.61C264.77,99.21,263.46,101.38,263.46,103.13z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st8",
    d: "M202.47,150.69c1.82,1.05,3.29,3.6,3.29,5.69c0,2.1-1.47,2.95-3.29,1.9 c-1.82-1.05-3.29-3.6-3.29-5.69S200.65,149.64,202.47,150.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    className: "st8",
    d: "M202.47,176.01c1.82,1.05,3.29,3.6,3.29,5.69c0,2.1-1.47,2.95-3.29,1.9 c-1.82-1.05-3.29-3.6-3.29-5.69C199.18,175.81,200.65,174.97,202.47,176.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_267_",
    className: "st7",
    d: "M201.45,151.19c1.82,1.05,3.29,3.6,3.29,5.69c0,2.1-1.47,2.95-3.29,1.9 c-1.82-1.05-3.29-3.6-3.29-5.69C198.17,151,199.64,150.15,201.45,151.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    className: "st7",
    d: "M201.45,176.52c1.82,1.05,3.29,3.6,3.29,5.69c0,2.1-1.47,2.95-3.29,1.9 c-1.82-1.05-3.29-3.6-3.29-5.69C198.17,176.32,199.64,175.47,201.45,176.52z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_294_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st10",
    d: "M352.27,87.99c0-2.23-1.57-3.14-3.51-2.02l-12.93,7.47l-95.12,54.92 c-1.94,1.12-3.5,3.84-3.5,6.07l0,200.69c0,2.24,1.57,3.14,3.5,2.02l95.15-54.94l12.9-7.45c1.94-1.12,3.51-3.84,3.51-6.07 L352.27,87.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M239.15,358.29c-0.45,0-0.87-0.11-1.25-0.33c-0.88-0.51-1.36-1.52-1.36-2.85l0-200.69 c0-2.49,1.69-5.41,3.84-6.65l95.12-54.92l0.67,1.17l-95.12,54.92c-1.72,0.99-3.17,3.5-3.17,5.49l0,200.69 c0,0.82,0.25,1.43,0.69,1.68c0.44,0.25,1.1,0.16,1.8-0.25l95.15-54.94l0.67,1.17l-95.15,54.94 C240.39,358.09,239.75,358.29,239.15,358.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M336.21,302.78l-0.67-1.17l12.9-7.45c1.72-0.99,3.17-3.51,3.17-5.49l0-200.69c0-0.82-0.25-1.43-0.69-1.68 c-0.44-0.25-1.09-0.16-1.8,0.25l-12.93,7.47l-0.67-1.17l12.93-7.47c1.15-0.66,2.27-0.75,3.15-0.25c0.88,0.51,1.36,1.52,1.36,2.85 l0,200.69c0,2.49-1.69,5.41-3.84,6.65L336.21,302.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st2",
    d: "M294.74,134.62c12.1-6.99,21.92-1.32,21.92,12.65s-9.81,30.97-21.92,37.96 c-12.1,6.99-21.92,1.32-21.92-12.65C272.83,158.61,282.64,141.61,294.74,134.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st2",
    d: "M294.74,145.62c3.93-2.27,7.11-0.43,7.11,4.1c0,4.53-3.18,10.05-7.11,12.32 c-3.93,2.27-7.11,0.43-7.11-4.11S290.81,147.89,294.74,145.62z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_274_",
    className: "st2",
    d: "M308.6,169.8c0-7.45-5.23-10.47-11.68-6.74l-4.03,2.33c-6.45,3.72-11.68,12.78-11.68,20.23v2 c3.73,1.24,8.42,0.57,13.54-2.39c5.26-3.04,10.08-7.96,13.86-13.71V169.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st12",
    d: "M294.74,145.62c3.93-2.27,7.11-0.43,7.11,4.1c0,4.53-3.18,10.05-7.11,12.32 c-3.93,2.27-7.11,0.43-7.11-4.11S290.81,147.89,294.74,145.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st12",
    d: "M308.6,169.8c0-7.45-5.23-10.47-11.68-6.74l-4.03,2.33c-6.45,3.72-11.68,12.78-11.68,20.23v2 c3.73,1.24,8.42,0.57,13.54-2.39c5.26-3.04,10.08-7.96,13.86-13.71V169.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_482_",
    className: "st2",
    d: "M252.34,216.06l28.2-16.28c1.29-0.74,2.34-0.14,2.34,1.35v0.93c0,1.49-1.05,3.3-2.34,4.05 l-28.2,16.28c-1.29,0.75-2.34,0.14-2.34-1.35v-0.93C250,218.62,251.05,216.81,252.34,216.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st13",
    d: "M252.34,216.06l28.2-16.28c1.29-0.74,2.34-0.14,2.34,1.35v0.93c0,1.49-1.05,3.3-2.34,4.05 l-28.2,16.28c-1.29,0.75-2.34,0.14-2.34-1.35v-0.93C250,218.62,251.05,216.81,252.34,216.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_483_",
    className: "st2",
    d: "M251.17,235.72l85.33-49.26c0.65-0.37,1.17-0.07,1.17,0.67v9.96c0,0.74-0.52,1.65-1.17,2.02 l-85.33,49.26c-0.64,0.37-1.17,0.07-1.17-0.67v-9.96C250,236.99,250.52,236.09,251.17,235.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st14",
    d: "M251.17,235.72l85.33-49.26c0.65-0.37,1.17-0.07,1.17,0.67v9.96c0,0.74-0.52,1.65-1.17,2.02 l-85.33,49.26c-0.64,0.37-1.17,0.07-1.17-0.67v-9.96C250,236.99,250.52,236.09,251.17,235.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_512_",
    className: "st2",
    d: "M252.34,260.35l28.2-16.28c1.29-0.74,2.34-0.14,2.34,1.35v0.93c0,1.49-1.05,3.3-2.34,4.05 l-28.2,16.28c-1.29,0.75-2.34,0.14-2.34-1.35v-0.93C250,262.91,251.05,261.09,252.34,260.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st13",
    d: "M252.34,260.35l28.2-16.28c1.29-0.74,2.34-0.14,2.34,1.35v0.93c0,1.49-1.05,3.3-2.34,4.05 l-28.2,16.28c-1.29,0.75-2.34,0.14-2.34-1.35v-0.93C250,262.91,251.05,261.09,252.34,260.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_511_",
    className: "st2",
    d: "M251.17,280l85.33-49.27c0.65-0.37,1.17-0.07,1.17,0.67v9.96c0,0.74-0.52,1.65-1.17,2.02 l-85.33,49.26c-0.64,0.37-1.17,0.07-1.17-0.67v-9.96C250,281.28,250.52,280.38,251.17,280z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st14",
    d: "M251.17,280l85.33-49.27c0.65-0.37,1.17-0.07,1.17,0.67v9.96c0,0.74-0.52,1.65-1.17,2.02 l-85.33,49.26c-0.64,0.37-1.17,0.07-1.17-0.67v-9.96C250,281.28,250.52,280.38,251.17,280z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_510_",
    className: "st2",
    d: "M285.21,285.66l33.68-19.45c1.29-0.75,2.34-0.14,2.34,1.35v10.42c0,1.49-1.05,3.3-2.34,4.05 l-33.68,19.45c-1.29,0.74-2.34,0.14-2.34-1.35V289.7C282.87,288.21,283.92,286.4,285.21,285.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st13",
    d: "M285.21,285.66l33.68-19.45c1.29-0.75,2.34-0.14,2.34,1.35v10.42c0,1.49-1.05,3.3-2.34,4.05 l-33.68,19.45c-1.29,0.74-2.34,0.14-2.34-1.35V289.7C282.87,288.21,283.92,286.4,285.21,285.66z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_276_",
    className: "st15",
    d: "M365.06,241.71c0,0-16.57-22.86-17.58-25.58c-0.76-2.05,0.05-5.1,0.24-6.52 c0.19-1.42,0.46-4.57,0.7-5.45c0.41-1.53-1.57-1.22-2.69,0.18c-1.14,1.43-1.51,4.21-2.07,4.67c-0.57,0.46-5-5.97-7.31-8.95 c-2.31-2.98-3.75-4.77-5.16-3.67c-1.01,0.8-0.26,2.53,1.42,5.06c1.67,2.53,2.42,3.71,2.67,4.25c0.25,0.54-1.12,0.59-1.87,1.73 c-0.58,0.89-0.04,2.34-0.81,3.03c-0.77,0.69-1.49,1.93-0.64,3.33c1.07,1.78,3.23,4.32,5.7,6.04c2.48,1.72,3.48,2.32,4.94,4.66 c1.46,2.33,14.66,26.17,15.55,27.6c0.89,1.43,2.61,4.34,5.21,4.43c2.61,0.08,23.91-18.26,25.01-19.18 c3.51-2.93,4.62-3.36,5.23-0.72c0.19,0.83,0.31,1.77,0.45,2.83c0.42,3.34,2.7,15.29,2.7,15.29s10.78,5.22,19.65,2.65 c8.87-2.57,11.85-6.28,11.85-6.28l-4.44-7.23c1.21-2.99,6.79-15.06,8.54-23.53l-27.79-4.49c-0.57-0.12-1.48-0.35-2.64-0.66 c-1.53-0.4-5.36-1.75-8.32,0.82C384.04,224.34,365.06,241.71,365.06,241.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_287_",
    className: "st8",
    d: "M420.15,381.91l-4.98,6.92c0,0,2.31,1.35,7.24,1.54c4.46,0.17,5.68-1.29,5.85-1.65 c0.75-1.61-0.42-4.53-0.74-7.03L420.15,381.91z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_284_",
    className: "st8",
    d: "M415.45,385.51c0,0-6.04-0.38-10.21-0.91c-4.17-0.53-7.48,1.51-6.49,3.23 c0.98,1.72,3.28,3.15,6.85,4.35c3.07,1.03,6.74,1.78,9.94,2.74c3.28,0.98,5.38,2.1,7.24,1.47c2.07-0.71,2.96-1.54,2.78-3.05 c-0.18-1.51-1.68-6.36-1.68-6.36L415.45,385.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_288_",
    className: "st16",
    d: "M428.25,374.95c0,0-0.75,6.29-0.81,7.64c-0.06,1.35-6.14,1.78-7.29-0.68l-0.19-7.69 L428.25,374.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    className: "st15",
    d: "M422.12,378.82l2.17,9.54c0,0,0.21,1.16-4.76,1.9c-4.97,0.74-12.76-2.6-14.09-3.28 c-1.33-0.68-1.48-2.03,3.39-1.76c4.88,0.27,6.61,0.28,6.61,0.28l-1.58-4.23L422.12,378.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    className: "st16",
    d: "M432.35,220.35l3.43-0.95c0,0,7.2,22.75,7.99,24.94c0.8,2.19,1.69,4.53,0.14,7.24 c-1.84,3.23-11.57,16.22-11.57,16.22l-6.17-6.04l7-12.83l-6.2-12.55L432.35,220.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_280_",
    className: "st8",
    d: "M396.99,190.78c0,0-2.75-4.41,0.15-9.81c3.42-6.36,11.06-9.46,20.16-8.27 c4.2,0.55,9.16,4,11.88,9.27c2.99,5.78,3.27,17.44,4.01,21.85L396.99,190.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14181_",
    className: "st15",
    d: "M396.78,193.26c0,0-2.16,4.11-1.79,4.49c0.37,0.37,1.82,0.68,1.82,0.68L396.78,193.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_",
    className: "st15",
    d: "M403.34,180.26c-2.35,1.53-6.4,4.33-6.57,13.58c-0.18,9.49,1.16,12.55,2.56,13.65 c0.95,0.74,6.49,0.37,8.87-0.19c2.38-0.56,9.22-3.94,11.68-9.08c2.9-6.04,2.31-14.9-2-17.47 C411.81,177.14,405.33,178.96,403.34,180.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    className: "st2",
    d: "M428.25,251.11c4.16,6.47,8.11,12.17,8.96,19.45c1.78,15.36-4.06,32.93-5.3,44.29 c0,0,3.93,5.1,3.92,11.1c0,4.69-7.57,49.01-7.57,49.01s-5.51,1.68-8.29-0.73l-5.2-81.52l2.74-9.92L428.25,251.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st3",
    d: "M428.25,251.11c4.16,6.47,8.11,12.17,8.96,19.45c1.78,15.36-4.06,32.93-5.3,44.29 c0,0,3.93,5.1,3.92,11.1c0,4.69-7.57,49.01-7.57,49.01s-5.51,1.68-8.29-0.73l-5.2-81.52l2.74-9.92L428.25,251.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st2",
    d: "M414.76,292.7l2.74-9.92c0,0,7.6-1.84,14.85-5.89c0,0-2.81,5.11-10.87,7.91l-4.2,12.76 l-0.36,29.19L414.76,292.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st17",
    d: "M414.76,292.7l2.74-9.92c0,0,7.6-1.84,14.85-5.89c0,0-2.81,5.11-10.87,7.91l-4.2,12.76 l-0.36,29.19L414.76,292.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_281_",
    className: "st2",
    d: "M428.25,251.11c2.23,3.63,7.55,9.84,6.42,15.81c-1.37,7.23-5.26,12.32-17.17,15.86 l-11.16,40.43c0,0,5.81,5.44,7.59,10.62c1.78,5.17,8.2,44.99,8.2,44.99s-1.99,3.24-8.26,2.46c0,0-21.87-49.94-23.41-53.16 c-1.54-3.22-2.54-5.62-1.85-10.86c0.7-5.24,8.14-62.52,8.14-62.52L428.25,251.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st3",
    d: "M428.25,251.11c2.23,3.63,7.55,9.84,6.42,15.81c-1.37,7.23-5.26,12.32-17.17,15.86 l-11.16,40.43c0,0,5.81,5.44,7.59,10.62c1.78,5.17,8.2,44.99,8.2,44.99s-1.99,3.24-8.26,2.46c0,0-21.87-49.94-23.41-53.16 c-1.54-3.22-2.54-5.62-1.85-10.86c0.7-5.24,8.14-62.52,8.14-62.52L428.25,251.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    className: "st2",
    d: "M432.35,220.35l-27.79-4.49c-0.57-0.12-1.49-0.36-2.65-0.66l0,0c0,0-1.18,17.42-8.31,21.42 h0c0.17,0.83,0.31,1.76,0.45,2.83c0.42,3.34,2.7,15.29,2.7,15.29s10.78,5.22,19.65,2.65c8.87-2.57,11.85-6.28,11.85-6.28 l-4.44-7.23C425.02,240.89,430.6,228.81,432.35,220.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st12",
    d: "M432.35,220.35l-27.79-4.49c-0.57-0.12-1.49-0.36-2.65-0.66l0,0c0,0-1.18,17.42-8.31,21.42 h0c0.17,0.83,0.31,1.76,0.45,2.83c0.42,3.34,2.7,15.29,2.7,15.29s10.78,5.22,19.65,2.65c8.87-2.57,11.85-6.28,11.85-6.28 l-4.44-7.23C425.02,240.89,430.6,228.81,432.35,220.35z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_543_",
    className: "st2",
    d: "M425.02,241.03c-0.11,0.26-8.93,4.99-11.55,5.71c4.13-0.2,7.56-1.18,10.34-2.87 L425.02,241.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_277_",
    className: "st8",
    d: "M402.65,180.72c0,0-1.29,8.77,1.84,13.92c0,0,1.18-3.49,4.14-2.82 c2.99,0.67,3.11,4.55,1.04,6.75c-2.07,2.2-4.38,1.4-4.38,1.4s-0.47,6.34-0.72,11.65c-0.24,5.12-1.67,16.9,4.31,21.63 c5.98,4.74,20.97,6.33,28-3.49c3.91-5.46-1.28-15.12-3.7-25.96c-2.22-9.96-3.47-24.72-14.04-27.08 C408.58,174.36,402.65,180.72,402.65,180.72z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_295_",
    className: "st1",
    d: "M441.41,60.92l-2.23,1.29c0.18-0.82,0.3-1.63,0.3-2.42c0-4.51-3.17-6.34-7.08-4.08 c-1.14,0.66-2.19,1.61-3.15,2.7c0-0.01,0-0.02,0-0.03c0-6.07-4.26-8.54-9.52-5.5c-5.26,3.04-9.53,10.42-9.53,16.5 c0,0.31,0.02,0.6,0.04,0.89c-1.11-0.2-2.44,0.07-3.87,0.9c-3.91,2.26-7.08,7.74-7.08,12.26c0,0.62,0.07,1.19,0.18,1.7l-1.19,0.68 c-3.23,1.86-5.84,5.5-5.84,8.12c0,2.62,2.61,3.23,5.84,1.37l43.11-24.89c3.23-1.86,5.84-5.5,5.84-8.12 C447.25,59.68,444.63,59.06,441.41,60.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRight);
export default __webpack_public_path__ + "static/media/login-right.9f2216d3474f6bd65f64f1e1c38729cc.svg";
export { ForwardRef as ReactComponent };